<template>
    <div v-if="!loading && accounts" class="w-full">
        <div v-if="total && total>10 && count" class="flex flex-1 align-items-center mb-3">
            <span class="text-xs text-400">{{ count }} из {{ total }} {{ content[lang_].trans }}</span>
        </div>

        <div v-if="accounts.length>0" class="w-full flex flex-column surface-0
            align-items-left overflow-hidden justify-content-start
            border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl">

            <div v-for="t of accounts" class="w-full flex flex-row px-3 py-3 gap-3 border-bottom-1 border-100">
                <div class="flex">
                    <AvatarGroup v-if="t.network || t.currency">
                        <Avatar v-if="t.currency" :image="GetCurrencyImage(t.currency)" size="small" shape="circle" />
                        <Avatar v-if="t.network" :image="GetNetworkImage(t.network)" size="small" shape="circle" />
                    </AvatarGroup>
                </div>
                <div class="flex flex-column flex-1 gap-1">
                    <span class="flex text-900 text-sm font-medium text-left">
                        {{ get_format_amount(t.balance, t.currency, 0) }}
                    </span>
                    <span class="flex flex-1 text-sm text-left text-400 uppercase font-medium">
                        {{ get_format_amount(t.balance, null, 6) }}
                    </span>
                </div>
            </div>
            <Paginator v-if="total && total>10" :rows="10" :first="skip" :totalRecords="total" :rowsPerPageOptions="[10, 20, 30]" @update:first="onChangePage" 
                template="PrevPageLink PageLinks NextPageLink" />
        </div>

        <div v-else class="w-full flex flex-column p-3 border-bottom-1 border-100">
            <span class="text-900 text-sm text-center">
                {{ content[lang_].empty }}
            </span>
        </div>

    </div>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'

export default {
    props: {
        accounts: { 
            type: Array, 
            default: () => [] 
        },
        skip: { 
            type: Number, 
            default: 10
        },
        total: { 
            type: Number, 
            default: 0 
        },
        loading: { 
            type: Boolean, 
            default: true 
        }
    },
    data() {
        return {
            wallet: null,
            content: {
                en: { 
                    empty: 'No transactions',
                    trans: 'transactions'
                },
                ru: { 
                    empty: 'Нет транзакций',
                    trans: 'транзакций'
                }
            },
            count: 0,
            currencies: []
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    watch: {
        transactions: {
            handler: function (val) {
                if(val){
                    this.count = val.length + this.skip
                    if(this.count > this.total) this.count = this.total
                }
            },
            deep: true
        }
    },
    methods: {
        get_format_amount(value, currency, digits = 4) {
            return this.helper.format_amount(value, currency, digits)
        },
        getFormatDate(date) {
            return this.helper.format_date_short(date)
        },
        onChangePage(event) {
            this.$emit('update:first', event)
        },
        onChangeRows(event) {
            this.$emit('update:rows', event)
        },
        GetNetworkImage(val){
            return this.helper.GetNetworkImage(val)
        },
        GetCurrencyImage(val){
            if(!val || this.currencies.length === 0) return null
            return this.helper.GetCurrencyImage(val, this.currencies)
        },
        getCurrencies(){
            const objList = (this.$store.getters.GetCurrencies) ? this.$store.getters.GetCurrencies : []
            if(!objList)return
            let currencies = []
            for(const [k,v] of Object.entries(objList)){
                currencies.push({
                    code: v.code,
                    name: k.toUpperCase(),
                    image: v.image
                })
            }
            this.currencies = currencies
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.getCurrencies()
    }
}
</script>